import { all, call, put, takeLeading } from "redux-saga/effects";
import { editAutoReservationRemindApi, getAutoReservationRemindListApi } from "apis/MCBNS010Api";
import { openModal, openSnackbar } from "reducers/messageReducer";
import { MCBNS010AutoReservationRemindInfo } from "pages/MCBNS010/formConfig";
import { getAutoReservationRemindList, editAutoReservationRemind, setAutoReservationRemindList, setAutoReservationRemindInfo, setCreateDialogOpen, linkSelectedTemplate, confirmAutoReservationRemind } from "reducers/autoReservationRemindReducer";
import { MCBNS020InitDisplayRequest } from "types/MCBNS020/MCBNS020InitDisplayRequest";
import { confirmAutoReservationRemindApi, linkSelectedTemplate1Api, linkSelectedTemplate2Api, openAutoReservationRemindApi } from "apis/MCBNS020Api";
import { MCBNS020AutoReservationRemindInfo } from "pages/MCBNS020/formConfig";
import { MCAMS030InitDisplayRequest } from "types/MCAMS030/MCAMS030InitDisplayRequest";
import { messageTemplateDetailRequest } from "apis/MCAMS030Api";
import { setDetailPageDialogOpen, setMessageTemplateDetailInit } from "reducers/messageTemplateReducer";
import { MCBNS010InitDisplayRequest } from "types/MCBNS010/MCBNS010InitDisplayRequest";

function* getAutoReservationRemindListSaga(action: ReturnType<typeof getAutoReservationRemindList>) {
  try {
    const data: MCBNS010AutoReservationRemindInfo = yield call(getAutoReservationRemindListApi, action.payload);
    yield put(setAutoReservationRemindList(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* editAutoReservationRemindSaga(action: ReturnType<typeof editAutoReservationRemind>) {
  try {
    yield call(editAutoReservationRemindApi, action.payload);
    const values: MCBNS020InitDisplayRequest = {
      targetYear: action.payload.targetYear,
      seminarId: action.payload.seminarId,
    }
    const resultData: MCBNS020AutoReservationRemindInfo = yield call(openAutoReservationRemindApi, values);
    yield put(setAutoReservationRemindInfo(resultData))
    yield put(setCreateDialogOpen(true))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* linkSelectedTemplateSaga(action: ReturnType<typeof linkSelectedTemplate>) {
  try {
    if (action.payload.index == '1') {
      yield call(linkSelectedTemplate1Api, action.payload.values)
    } else {
      yield call(linkSelectedTemplate2Api, action.payload.values)
    }
    const param: MCAMS030InitDisplayRequest = {
      templateId: action.payload.values.templateId.toString(),
      recruitmentManagementDivision: action.payload.values.recruitmentManagementDivision
    }
    const data = yield call(messageTemplateDetailRequest, param)
    yield put(setMessageTemplateDetailInit(data))
    yield put(setDetailPageDialogOpen(true))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* confirmAutoReservationRemindSaga(action: ReturnType<typeof confirmAutoReservationRemind>) {
  try {
    const message: string = yield call(confirmAutoReservationRemindApi, action.payload)
    yield put(setCreateDialogOpen(false))
    const param1: MCBNS010InitDisplayRequest = {
      targetYear: action.payload.targetYear
    }
    const data: MCBNS010AutoReservationRemindInfo = yield call(getAutoReservationRemindListApi, param1);
    yield put(setAutoReservationRemindList(data))
    yield put(openSnackbar(message))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* autoReservationRemindSaga() {
  yield all([
    takeLeading(getAutoReservationRemindList, getAutoReservationRemindListSaga),
    takeLeading(editAutoReservationRemind, editAutoReservationRemindSaga),
    takeLeading(linkSelectedTemplate, linkSelectedTemplateSaga),
    takeLeading(confirmAutoReservationRemind, confirmAutoReservationRemindSaga),
  ])
}